var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useEffect, useState } from "react";
import { BreadCrumbSteps, BreadCrumbStepsVariant } from "@sequentech/ui-essentials";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTranslation } from "react-i18next";
import { TallyStyles } from "@/components/styles/TallyStyles";
import { useGetOne, useNotify } from "react-admin";
import { WizardStyles } from "@/components/styles/WizardStyles";
import { CancelButton, NextButton } from "./styles";
import { EditTallySheet } from "./EditTallySheet";
import { ShowTallySheet } from "./ShowTallySheet";
export var WizardSteps = {
    List: -1,
    Start: 1,
    Edit: 2,
    Confirm: 3,
    View: 4,
};
export var TallySheetWizard = function (props) {
    var action = props.action, contest = props.contest, tallySheetId = props.tallySheetId, doAction = props.doAction;
    var submitRef = React.useRef(null);
    var notify = useNotify();
    var t = useTranslation().t;
    var _a = useState(WizardSteps.Edit), page = _a[0], setPage = _a[1];
    var _b = useState(), areaId = _b[0], setAreaId = _b[1];
    var _c = useState(), createdTallySheet = _c[0], setCreatedTallySheet = _c[1];
    var _d = useState(), editedTallySheet = _d[0], setEditedTallySheet = _d[1];
    var _e = useState(false), isButtonDisabled = _e[0], setIsButtonDisabled = _e[1];
    var tallySheet = useGetOne("sequent_backend_tally_sheet", { id: tallySheetId }).data;
    useEffect(function () {
        if (action) {
            setPage(action);
        }
    }, [action]);
    var handleNext = function () {
        var _a, _b;
        if (page === WizardSteps.Start || page === WizardSteps.Edit) {
            (_a = submitRef.current) === null || _a === void 0 ? void 0 : _a.click();
            // needs to wait for the click handler to submit the data
            setTimeout(function () {
                var tallySheet = localStorage.getItem("tallySheetData");
                if (tallySheet) {
                    doAction(WizardSteps.Confirm);
                }
                else {
                    notify(t("tallysheet.allFieldsRequired"), { type: "error" });
                }
            }, 400);
        }
        else if (page === WizardSteps.Confirm) {
            (_b = submitRef.current) === null || _b === void 0 ? void 0 : _b.click();
            doAction(WizardSteps.List);
        }
    };
    var handleBack = function () {
        var tallySheet = localStorage.getItem("tallySheetData");
        var tallySheetTemp = JSON.parse(tallySheet || "{}");
        if (page === WizardSteps.Start) {
            doAction(WizardSteps.List);
        }
        else if (page === WizardSteps.Edit) {
            doAction(WizardSteps.List);
        }
        else if (page === WizardSteps.Confirm) {
            if (tallySheetId && tallySheetTemp && tallySheetTemp.id) {
                doAction(WizardSteps.List);
            }
            else {
                doAction(WizardSteps.Edit);
            }
        }
        else if (page === WizardSteps.View) {
            doAction(WizardSteps.List);
        }
    };
    return (_jsx(_Fragment, { children: _jsxs(WizardStyles.WizardWrapper, { children: [_jsx(TallyStyles.StyledHeader, { children: _jsx(BreadCrumbSteps, { labels: [
                            "tallysheet.breadcrumbSteps.edit",
                            page === WizardSteps.View
                                ? "tallysheet.breadcrumbSteps.view"
                                : "tallysheet.breadcrumbSteps.confirm",
                        ], selected: page, variant: BreadCrumbStepsVariant.Circle, colorPreviousSteps: true }) }), page === WizardSteps.Start && (_jsx(_Fragment, { children: _jsx(EditTallySheet, { contest: contest, doSelectArea: function (id) { return setAreaId(id); }, doCreatedTalySheet: function (tallySheet) {
                            setCreatedTallySheet(tallySheet);
                        }, submitRef: submitRef }) })), page === WizardSteps.Edit && (_jsx(_Fragment, { children: _jsx(EditTallySheet, { tallySheet: tallySheet, contest: contest, doCreatedTalySheet: function (tallySheet) {
                            setCreatedTallySheet(tallySheet);
                        }, submitRef: submitRef }) })), page === WizardSteps.Confirm && (_jsx(_Fragment, { children: _jsx(ShowTallySheet, { tallySheet: createdTallySheet || tallySheet, contest: contest, doEditedTalySheet: function (tallySheet) {
                            return setEditedTallySheet(tallySheet);
                        }, submitRef: submitRef }) })), page === WizardSteps.View && (_jsx(_Fragment, { children: _jsx(ShowTallySheet, { tallySheet: tallySheet, contest: contest, doEditedTalySheet: function (tallySheet) {
                            return setEditedTallySheet(tallySheet);
                        }, submitRef: submitRef }) })), _jsxs(TallyStyles.StyledFooter, { children: [_jsx(CancelButton, __assign({ className: "list-actions", onClick: handleBack }, { children: t("tallysheet.common.cancel") })), page !== WizardSteps.View && (_jsx(NextButton, __assign({ color: "primary", onClick: handleNext, disabled: isButtonDisabled }, { children: _jsxs(_Fragment, { children: [page === WizardSteps.Edit
                                        ? t("tallysheet.common.confirm")
                                        : page === WizardSteps.Confirm
                                            ? t("tallysheet.common.save")
                                            : t("tallysheet.common.next"), _jsx(ChevronRightIcon, {})] }) })))] })] }) }));
};
